import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Collapse, Card, CardBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CardHeader } from '@cordata/buffet';
import { findIndex } from 'lodash';

const Accordian = ({
  items,
  openPanel: op,
  setOpenPanel,
  allOpen,
}) => {
  const [openCollapse, setOpenCollapse] = useState();

  useEffect(() => {
    if (op !== null || op !== undefined) {
      setOpenCollapse(typeof op === 'number' ? op : findIndex(items, i => i.title === op));
    }
  }, [items, op]);

  const isOpen = i =>
    i === openCollapse || allOpen || items.length === 1;

  return (
    <Card>
      {items.map(({ title, titleAction, body }, i) => (
        <React.Fragment key={title}>
          <CardHeader
            onClick={() => {
              setOpenCollapse(i === openCollapse ? -1 : i);
              setOpenPanel(i === openCollapse ? undefined : title);
            }}
            className="text-uppercase font-weight-bold d-print-none"
            style={{
              backgroundColor:
                isOpen(i) ? '#ced4da' : 'white',
            }}
          >
            <FontAwesomeIcon
              icon={
                isOpen(i) ? 'chevron-down' : 'chevron-right'
              }
              className="mr-2 text-muted"
              fixedWidth
            />
            <div className="d-inline-flex align-items-center">
              <span style={{ color: '#1d3b4e' }}>{title}</span>
              {openCollapse === i && titleAction}
            </div>
          </CardHeader>

          {(isOpen(i)) && (
            <>
              <h3 className="d-none d-print-block ml-4 mt-3">{title}</h3>
            </>
          )}

          <Collapse isOpen={isOpen(i)}>
            {(isOpen(i)) && (
              <CardBody className="print-table">{body}</CardBody>
            )}
          </Collapse>
        </React.Fragment>
      ))}
    </Card>
  );
};

Accordian.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
    body: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
  })).isRequired,
  openPanel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setOpenPanel: PropTypes.func,
  allOpen: PropTypes.bool,
};

Accordian.defaultProps = {
  openPanel: -1,
  allOpen: false,
  setOpenPanel: () => {},
};

export default Accordian;
